<template>
    <div>
        <p>©{{year}} {{company}} <br class="hidden-xxs-and-up">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{icp}}</a> 
            {{right}}
        </p>
        <p>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37069102000126" target="_blank">
                <img src="../../assets/police.png" alt="">
                {{police}}
            </a>
        </p>
    </div>
    
</template>

<script>
export default {
    data(){
        return{
            year: '',
            company: '山东医影智能科技有限公司',
            icp: '鲁ICP备20004201号-1',
            police: '鲁公网安备 37069102000126号',
            right: '版权所有',
            wWidth : window.screen.width
        }
    },
    created(){
        this.addDate();
    },
    methods:{
        addDate(){
            const nowDate = new Date();
            const date = {
                year: nowDate.getFullYear()
            }
            this.year = date.year;
        }
    }
}
</script>

<style lang="scss" scoped>
p{
    margin: 0;
    // padding: vw(16) 0 vw(32);
    color: white;
    background: $yyBlue;

    &:first-of-type{
        padding: vw(16) 0;
    }

    &:last-of-type{
        padding: 0 0 vw(16);

        img{
            margin-right: 5px;
        }
        
        a{
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    a,
    a:hover,
    a:active{
        color: white;
    }

    @media screen and (max-width: 767px){
        font-size: vp(16);
        // padding: vp(22) vp(10) vp(32);
        color: $font28;
        background: white;

        &:first-of-type{
            padding: vp(22) 0;
        }

        &:last-of-type{
            padding: 0 0 vp(22);
        }

        a,
        a:hover,
        a:active{
            color: $font28;
        }
    }

    @media screen and (min-width: 360px){
        .hidden-xxs-and-up{
            display: none;
        }
    }
}
</style>